export default __webpack_public_path__ + "static/SRUS P193L4 - Especification Del Producto y Datos Técnicos-df728ba747ed5c389da476e6a53817f2.pdf";